/**
 * Atlas PM · 指标与要素契约（P2）
 *
 * 本文件是跨会话接口冻结的载体：前端、API、Agent 都消费这里的类型。
 * 修改须走 ops/变更申请.md。
 *
 * ⭐ 核心铁律：进度是**算出来的**，永远不接受人工输入。
 *   【完成度链路】要素完成度 → 指标完成度 → 任务完成度
 *   【质量链路】  要素质量   → 指标质量   → 任务质量（平行，互不影响）
 *   算法实现见 `packages/shared/src/progress.ts`，前后端必须共用同一份。
 *   ⚠️ 两条链路返回值均为 0-100 的百分数。
 */
/** 要素类型 */
export const ELEMENT_TYPE = {
    BOOL: 'BOOL', // 是/否
    NUMBER: 'NUMBER', // 数值
    TEXT: 'TEXT', // 文本
    DATE: 'DATE', // 日期
    ENUM: 'ENUM', // 枚举（约束里给 options）
    FILE: 'FILE', // 文件（关联 file_object）
};
//# sourceMappingURL=metric.js.map